import { render } from "./HospitalForm.vue?vue&type=template&id=cb8259ce&scoped=true"
import script from "./HospitalForm.vue?vue&type=script&lang=js"
export * from "./HospitalForm.vue?vue&type=script&lang=js"

import "./HospitalForm.vue?vue&type=style&index=0&id=cb8259ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb8259ce"]])

export default __exports__